import React, { useEffect } from "react";
import styles from "../onboard.module.css";
import { Button, Col, Row, Spinner } from "react-bootstrap";
import SignInInput from "../../../common/SigninInput/signinInput";
import Dropdown from "../../Dropdown/dropdown";
import { useState } from "react";
import CommonButton from "../../CommonButton/CommonButton";
import { useMyContext } from "../../../myContext";

function Beneficiaryform({
  name,
  handleChange,
  valid,
  nameError,
  handleBlur,
  countryOptions,
  country,
  handleChangeOptionforCountry,
  email,
  emailError,
  phoneNumber,
  setPhoneNumber,
  countryCode,
  phoneNoError,
  postalCode,
  postalError,
  address,
  city,
  state,
  nextSectionError,
  checkIfValid,
  loading,
  indianCountryCode,
  handleCountryCheck,
  fixedCountry,
  themeColor,
  // referenceNumber
}) {
  const [subPurpose, setSubPurpose] = useState("");
  const { countryObject } = useMyContext();

  let currencyOption = [];

  countryObject?.currencyList.forEach((key) => {
    currencyOption.push({
      label: key,
      value: key,
    });
  });

  useEffect(() => {
    setSubPurpose(sessionStorage.getItem("subPurpose"));
  }, [indianCountryCode]);

  return (
    <div>
      <Row>
        <Col md={4}>
          <SignInInput
            name="name"
            label="University/Beneficiary Full Name"
            placeholder="Enter Full Name"
            type="text"
            value={name}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              handleChange(event);
            }}
            isInvalid={valid.name}
            errorMessage={nameError}
            onBlur={(event) => {
              handleBlur(event);
            }}
          />
        </Col>
        <Col md={4}>
          <SignInInput
            name="email"
            label="Email ID"
            placeholder="Enter Email ID"
            type="text"
            value={email}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              handleChange(event);
            }}
            errorMessage={emailError}
            isInvalid={valid.email}
            onBlur={(event) => {
              handleBlur(event);
            }}
          />
        </Col>
        <Col md={4}>
          {fixedCountry !== "" ? (
            <SignInInput
              name="Country"
              label="Country"
              placeholder={country}
              type="text"
              value={country}
              containerClasses={styles.passwordInvalid}
              disabled={true}
              // onChange={(event) => {
              //   handleChange(event);
              // }}
            />
          ) : (
            <Dropdown
              options={countryOptions}
              heading="Country"
              label={country ? country : "Select Country"}
              onChange={handleChangeOptionforCountry}
              labelstyle={country ? true : false}
              search={true}
            />
          )}
        </Col>
      </Row>
      <Row className="pt-2">
        <Col md={4}>
          <SignInInput
            name="phoneNumber"
            label="Phone Number"
            placeholder="Enter Phone Number"
            type="number"
            value={phoneNumber}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              setPhoneNumber(event.target.value);
            }}
            onPaste={(e) => {
              e.preventDefault();
              return false;
            }}
            onCopy={(e) => {
              e.preventDefault();
              return false;
            }}
            isInvalid={valid.phoneNumber}
            onBlur={(event) => {
              handleBlur(event);
            }}
            showcodediv={true}
            codedivName={
              indianCountryCode === true ? "phone" : "countryMapping"
            }
            countryCode={
              subPurpose === "GIC"
                ? "+1"
                : subPurpose === "Blocked Account"
                ? "+49"
                : countryCode
            }
            errorMessage={phoneNoError}
          />
          {subPurpose !== "Rent Payment And Expenses" && (
            <div class="form-check" className={styles.checkMark}>
              <input
                class="form-check-input"
                className={styles.checkbox}
                type="checkbox"
                id="flexCheckDefault"
                checked={indianCountryCode}
                onChange={handleCountryCheck}
              />
              <label
                class="form-check-label"
                className={styles.checklabel}
                for="flexCheckDefault"
              >
                Check to use Indian phone number
              </label>
            </div>
          )}
        </Col>
        <Col md={4}>
          <SignInInput
            name="Postal"
            label="Postal Code"
            placeholder="Enter Postal Code"
            type="number"
            value={postalCode}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              handleChange(event);
            }}
            onBlur={(event) => {
              handleBlur(event);
            }}
            isInvalid={valid.postalCode}
            errorMessage={postalError}
          />
        </Col>
        <Col md={4}>
          <SignInInput
            name="Address"
            label="Address"
            placeholder="Enter Full Address"
            type="text"
            value={address}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              handleChange(event);
            }}
            isInvalid={valid.address}
          />
        </Col>
      </Row>
      <Row className="pt-2">
        <Col md={4}>
          <SignInInput
            name="City"
            label="City"
            placeholder="Enter City"
            type="text"
            value={city}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              handleChange(event);
            }}
            isInvalid={valid.city}
          />
        </Col>
        <Col md={4}>
          <SignInInput
            name="State"
            label="State"
            placeholder="Enter State"
            type="text"
            value={state}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              handleChange(event);
            }}
            isInvalid={valid.state}
          />
        </Col>
        {/* <Col md={4}>
          <SignInInput
            name="reference number"
            label="Reference Number"
            placeholder="Enter Reference Number"
            type="text"
            value={referenceNumber}
            containerClasses={styles.passwordInvalid}
            onChange={(event) => {
              handleChange(event);
            }}
            // isInvalid={valid.state}
          />
        </Col> */}
      </Row>
      <Row className="pt-3 mt-3">
        <div className={styles.errorState}>{nextSectionError}</div>
        <CommonButton
          title="Next"
          onClick={checkIfValid}
          loading={loading}
          disabled={loading}
          width={"150px"}
        />
      </Row>
    </div>
  );
}

export default Beneficiaryform;
